import { render, staticRenderFns } from "./TechShare.vue?vue&type=template&id=22719e44&"
import script from "./TechShare.vue?vue&type=script&lang=js&"
export * from "./TechShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports